
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

// Services
import ErrorService from '@/utils/ErrorService';

// Api
import { createCity, updateCity } from '@/utils/api/Cities';

// Interfaces
import City from '@/ship/Models/City';
import CityEditModel from '@/ship/Models/CityEditModel';
import CityEditRequest from '@/ship/Requests/CityEditRequest';

// Components
import { ValidationObserver, ValidationProvider } from 'vee-validate';

import VAdministrationForm from '@/components/Administration/VAdministrationForm.vue';

import VInput from '@/components/VInput.vue';
import VInputNumeric from '@/components/VInputNumeric.vue';
import VButton from '@/components/VButton/VButton.vue';
import VFormField from '@/components/VFormField.vue';

// Utils
import { pick } from 'lodash';

@Component({
    components: {
        ValidationObserver,
        ValidationProvider,

        VAdministrationForm,

        VFormField,
        VInput,
        VInputNumeric,
        VButton,
    },
})
export default class VAdministrationCityForm extends Vue {
    // If the city property exists, it means that the form is updating user, not creating it
    @Prop({ type: Object, default: null })
    public city!: City | null;

    public isLoading: boolean = false;

    public model: CityEditModel = {
        district: null,
        name: '',
    };

    public get isCreating() {
        return !this.city;
    }

    @Watch('city')
    public cityWatchHandler() {
        if (this.city) this.model = pick(this.city, ['name', 'district']);
    }

    public async handleSubmit() {
        this.isLoading = true;

        try {
            await (this.isCreating
                ? createCity(this.model as CityEditRequest)
                : updateCity(this.city!.id, this.model as CityEditRequest));

            this.$emit('submit');
        } catch (error) {
            ErrorService.handleApiError(error);
            this.$emit('submit-errored', error);
        } finally {
            this.isLoading = false;
        }
    }

    public async created() {
        this.cityWatchHandler();
    }
}
